import React from "react";
import { Link } from "gatsby";
import { SLA_RESIDENTAL_EMPLOYED, SLA_RESIDENTAL_SELF_EMPLOYED, SLA_BUY_TO_LET } from "../../data/sla.data";
import { triggerTealiumEvent } from "../../utils/tealiumUtils";
import { useLocation } from "@reach/router";
import Image from "../../assets/images/calendar-calculator.jpg";

const ServiceStrip = () => {
  const location = useLocation();

  const handleClick = () => {
    triggerTealiumEvent(
      "link",
      location.href,
      "content",
      "button",
      "Service levels",
      "product information",
      "Home",
      "10451v5"
    );
  };

  return (
    <div className="col-xs-12 col-xl-9">
      <div className="service-strip">
        <img src={Image} alt=""/>
        <div className="service-strip__text-wrap">
          <h2 className="service-strip__title">Our latest service levels</h2>
          <Link to="/our-latest-service-levels" rel="noreferrer" onClick={() => handleClick()}>
            <p>Find out when your case will be assessed</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServiceStrip;
